import React from "react";
import { Row, Breadcrumb } from "antd";
import { Link } from "react-router-dom";


export default function BreadcrumbComponent({ type, collectionId }) {
  return (
    <>
      <Row style={{top:0}}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"> Home</Link>
          </Breadcrumb.Item>
           
          <Breadcrumb.Item>
            {type ? "" : (
              <Link to="/create-collection">Create Catalogue</Link>
            )}
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/select-products/${collectionId}`}>
              Product selection
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit Details</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    </>
  );
}
